export interface HeaderRoute {
  label: string;
  path: string;
}

export function headerRouteTitle(pathname: string, routes: HeaderRoute[] = []): string {
  const path = pathname.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';
  const match = [...routes]
    .sort((left, right) => right.path.length - left.path.length)
    .find(route => {
      const routePath = route.path.replace(/\/+$/, '') || '/';
      if (routePath === '/') return path === '/';
      return path === routePath || path.startsWith(`${routePath}/`);
    });
  if (match) return match.label;

  const segment = path.split('/').filter(Boolean).pop();
  if (!segment) return 'Home';
  return segment
    .split(/[-_]/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
